// extracted by mini-css-extract-plugin
export default {"button":"mk-z","reviewSort":"nk-z"};